<template>
    <div>
        <PageHeader :title="title" :items="items" />

        <div class="card w-100">
            <div class="card-body">
                <div class="row align-items-center">
                    <div class="col">
                        <h3 class="card-title mb-1">Trouver un stagiaire</h3>
                        <p class="text-muted font-size-12 mb-0">Séléctionner un stagiaire pour voir ses informations et questionnaires</p>
                    </div>
                    <div class="col-6">
                        <multiselect v-model="selectedStudent" :options="studentsList" placeholder="" track-by="id" :show-labels="false" :internal-search="false" @search-change="onSearch">
                            <template #noResult>
                                Aucun stagiaire trouvé!
                            </template>
                            <template #noOptions>
                                Veuillez saisir le nom, prénom, ou CEF
                            </template>
                            <template #singleLabel="{option}">{{ option.nom }} {{ option.prenom }}</template>
                            <template #option="{option}"> {{ option.nom }} {{ option.prenom }} - {{ option.cef }} </template>
                        </multiselect>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-9 d-flex flex-wrap">
                <div class="card w-100">
                    <div class="card-body">
                        <vue-form-generator ref="form" tag="div" :schema="studentSchema" :model="selectedStudent" :options="{ validateAfterChanged: true }" />
                        <div class="d-flex justify-content-end mt-3">
                            <q-button :disabled="!selectedStudent" :loading="submitLoading" @click="onChangeSubmit">Valider les changements</q-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 d-flex">
                <div class="card w-100">
                    <div class="card-body d-flex flex-column">
                        <h3 class="card-title mb-4">Questionnaire par filière</h3>
                        <p class="text-muted font-size-12 flex-fill">
                            Vous trouverez ci-dessous la liste des formations lié au stagiaire séléctionné, vous pouvez commencer un questionnaire ou le consulter s'il est déja créé
                        </p>

                        <template v-if="selectedStudent">
                            <div class="p-3 mt-3 border border-primary rounded d-flex flex-column" v-for="(item, index) in selectedStudent.filieres" :key="index">
                                <h4 class="font-size-14 mb-1">{{ item.nom }}</h4>
                                <p class="font-size-12 font-weight-semibold text-primary mb-0">{{ item.anneeScolaire }}</p>

                                <div class="d-flex justify-content-between align-items-center mt-3">
                                    <p class="font-size-12 text-muted mb-0">{{ item.date }}</p>
                                    <b-button @click="onFormationClick(selectedStudent, item)" variant="primary" size="sm" pill>{{
                                        item.date ? "Consulter l'enquête" : "Commencer l'enquête"
                                    }}</b-button>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <SurveyModal :student="modalStudent" @submited="onSurveySubmited" />
    </div>
</template>

<script>
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import { debounce } from "@/helpers/functions";
    import SurveyModal from "@/components/survey-modal";

    export default {
        page: {
            title: "Questionnaire",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            PageHeader,
            SurveyModal
        },
        data: () => ({
            title: "Questionnaire",
            items: [],
            villes: [],
            data: {},
            studentsList: [],
            selectedStudent: null,
            modalStudent: null,
            editDisabled: true,
            submitLoading: false,
            loading: false
        }),
        methods: {
            onSurveySubmited(filiere) {
                if (!filiere) return;
                const index = this.selectedStudent.filieres.findIndex(item => item.id == filiere.id);
                this.selectedStudent.filieres.splice(index, 1, filiere);
            },
            async onSearch(search) {
                const efp = localStorage.getItem("selected-efp");
                const typeEfp = localStorage.getItem("selected-efp-type");
                const students = await this.$axios.get("/students/search", { params: { efp, typeEfp, search } });
                this.studentsList = students;
            },
            onFormationClick(selectedStudent, filiere) {
                this.modalStudent = {
                    nom: selectedStudent.nom,
                    prenom: selectedStudent.prenom,
                    filiere: filiere.nom,
                    stagiaireFiliere: filiere.stagiaireFiliere,
                    date: filiere.date
                };

                this.$nextTick(() => {
                    this.$bvModal.show("quest-modal");
                });
            },
            onEFPChanged() {
                this.selectedStudent = null;
                this.studentsList = [];
            },
            async onChangeSubmit() {
                this.submitLoading = true;
                const { id, tel, tel_parent, email, adresse, ville } = this.selectedStudent;
                await this.$axios.put("/students", {
                    id,
                    tel,
                    tel_parent,
                    email,
                    adresse,
                    ville
                });
                this.submitLoading = false;
            }
        },
        mounted() {
            this.mitt.on("efp-changed", this.onEFPChanged);

            this.$axios.get("/params/villes").then(villes => (this.villes = villes));
        },
        beforeDestroy() {
            this.mitt.off("efp-changed", this.onEFPChanged);
        },
        created() {
            this.onSearch = debounce(this.onSearch, 500);
        },
        computed: {
            studentSchema() {
                return {
                    groups: [
                        {
                            styleClasses: "row",
                            fields: [
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Nom",
                                    model: "nom",
                                    styleClasses: "col-md-3 font-size-12 text-muted",
                                    disabled: true
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Prénom",
                                    model: "prenom",
                                    styleClasses: "col-md-3 font-size-12 text-muted",
                                    disabled: true
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Nom AR",
                                    model: "nom_ar",
                                    styleClasses: "col-md-3 font-size-12 text-muted",
                                    disabled: true
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Prénom AR",
                                    model: "prenom_ar",
                                    styleClasses: "col-md-3 font-size-12 text-muted",
                                    disabled: true
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "CEF",
                                    model: "cef",
                                    styleClasses: "col-md-3 font-size-12 text-muted",
                                    disabled: true
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "CIN",
                                    model: "cin",
                                    styleClasses: "col-md-3 font-size-12 text-muted",
                                    disabled: true
                                },

                                {
                                    type: "b-radios",
                                    label: "Genre",
                                    model: "genre",
                                    buttons: true,
                                    buttonVariant: "outline-dark",
                                    //valueField: "id",
                                    //textField: "nom",
                                    values: ["H", "F"],
                                    styleClasses: "col-md-3 font-size-12 text-muted",
                                    attributes: {
                                        class: `w-100 ${this.editDisabled ? "disabled" : ""}`
                                    }
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Date de naissance",
                                    model: "dateNaissance",
                                    styleClasses: "col-md-3 font-size-12 text-muted",
                                    disabled: this.editDisabled
                                },
                                {
                                    type: "input",
                                    inputType: "tel",
                                    label: "Tel",
                                    model: "tel",
                                    styleClasses: "col-md-4 font-size-12 text-muted",
                                    max: 10,
                                    validator: "string"
                                },
                                {
                                    type: "input",
                                    inputType: "tel",
                                    label: "Tel Parent",
                                    model: "tel_parent",
                                    styleClasses: "col-md-4 font-size-12 text-muted",
                                    max: 10,
                                    validator: "string"
                                },
                                {
                                    type: "input",
                                    inputType: "email",
                                    label: "Email",
                                    model: "email",
                                    styleClasses: "col-md-4 font-size-12 text-muted",
                                    max: 50,
                                    validator: "string"
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Adresse",
                                    model: "adresse",
                                    styleClasses: "col-md-8 font-size-12 text-muted",
                                    max: 100,
                                    validator: "string"
                                },
                                {
                                    type: "multiselect",
                                    label: "Ville",
                                    model: "ville",
                                    styleClasses: "col-md-4 font-size-12 text-muted",
                                    values: this.villes,
                                    selectOptions: { label: "", trackBy: "" }
                                }
                            ]
                        }
                    ]
                };
            }
        }
    };
</script>

<style>
    #sidebar-right___title__ {
        font-size: 18px;
    }

    .custom-radio,
    .custom-checkbox {
        margin-bottom: 4px;
    }
</style>
